import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HStack } from '@chakra-ui/react';

import AddNewButton from '../../../../components/AddNewButton';
import PageHeader from '../../../../components/PageHeader';
import SearchInputGroup from '../../../../components/SearchInputGroup';
import { CypressIds } from '../../../../constants/cypressIds';
import { getCompanyUsers, selectCompanyId } from '../../../../redux/modules/company';
import { selectModalPreviousState, showModal } from '../../../../redux/modules/modal';
import { globalRequirementTemplateBuilder } from '../../../../redux/reducer';
import CreateTemplateModal from '../modals/CreateTemplateModal';
import TemplatesFilter from '../TemplatesFilter';

const TemplatesPageHeader = () => {
  const dispatch = useDispatch();
  const previousState = useSelector(selectModalPreviousState);
  const companyId = useSelector(selectCompanyId);
  const { searchFilter } = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplates);

  useEffect(() => {
    if (companyId) dispatch(getCompanyUsers(companyId));
  }, [companyId]);

  const showCreateModal = () => {
    dispatch(showModal(
      CreateTemplateModal,
      {
        title: 'Create Template',
        size: '4xl',
        withHistory: true,
        buttons: { withHistoryButton: !!previousState }
      }
    ));
  };

  const onChange = evt => dispatch(
    globalRequirementTemplateBuilder.setCurrentRequirementTemplateSearchFilter(evt.target.value)
  );

  return (
    <PageHeader cypressId={CypressIds.reqTemplatesPageHeader} title="Templates">
      <HStack spacing={2}>
        <SearchInputGroup
          searchTerm={searchFilter}
          variant="secondary"
          width="255px"
          onChange={onChange}
        />
        <TemplatesFilter blueprint={globalRequirementTemplateBuilder} />
        <AddNewButton cypressId={CypressIds.reqTemplatesCreateNewTemplateButton} minWidth="175px" tabName="New Template" onClick={showCreateModal} />
      </HStack>
    </PageHeader>
  );
};

export default TemplatesPageHeader;
